/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.5 3c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5ZM24 3c0 1.6569-1.3431 3-3 3a3.0354 3.0354 0 0 1-.28-.0129l-1.9984 3.9968c.4837.5326.7784 1.2399.7784 2.0161 0 1.6569-1.3431 3-3 3-1.3979 0-2.5725-.9561-2.9055-2.25h-3.189C10.0725 14.0439 8.8979 15 7.5 15a2.9958 2.9958 0 0 1-.9583-.1563l-1.842 3.6839C5.4851 19.0686 6 19.9742 6 21c0 1.6569-1.3431 3-3 3-1.6568 0-3-1.3431-3-3s1.3432-3 3-3c.0944 0 .1878.0044.28.0129l1.9984-3.9968A2.9889 2.9889 0 0 1 4.5 12c0-1.6569 1.3431-3 3-3 1.3979 0 2.5725.956 2.9055 2.25h3.189C13.9275 9.956 15.1021 9 16.5 9c.3351 0 .6574.055.9583.1563l1.842-3.684C18.5149 4.9314 18 4.0259 18 3c0-1.6568 1.3431-3 3-3s3 1.3432 3 3ZM7.5 13.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5S6 11.1716 6 12s.6716 1.5 1.5 1.5ZM15 12c0 .8284.6716 1.5 1.5 1.5S18 12.8284 18 12s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5ZM3 22.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z"
    clipRule="evenodd"
  />,
  'Status'
);
